var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340.99988 340.99991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d5d5dd;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.50006,122.99994c-25.95752,0-47,21.04266-47,47s21.04248,46.99997,47,46.99997,47-21.04266,47-46.99997-21.04266-47-47-47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.50006,249.8187c-42.63379,0-77.31897-34.68494-77.31897-77.31876s34.68518-77.31897,77.31897-77.31897,77.31873,34.68518,77.31873,77.31897-34.68494,77.31876-77.31873,77.31876M170.50006,63.99997c-59.92303,0-108.49994,48.57697-108.49994,108.49997s48.5769,108.49997,108.49994,108.49997,108.49994-48.57718,108.49994-108.49997-48.57715-108.49997-108.49994-108.49997"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.50006,309.81894c-37.21344,0-72.19965-14.49179-98.51324-40.80585-26.31403-26.31357-40.80585-61.2998-40.80585-98.51324s14.49182-72.19946,40.80585-98.51328c26.3136-26.31381,61.2998-40.80557,98.51324-40.80557s72.19946,14.49176,98.51324,40.80557c26.31384,26.31381,40.8056,61.29984,40.8056,98.51328s-14.49176,72.19968-40.8056,98.51324c-26.31378,26.31406-61.2998,40.80585-98.51324,40.80585M170.50006,0C76.33533,0,0,76.3353,0,170.49985s76.33533,170.50006,170.50006,170.50006,170.49982-76.33551,170.49982-170.50006S264.66461,0,170.50006,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBackground);
export default __webpack_public_path__ + "static/media/CircleBackground.80dad3fd6fca73b55a92e1a120d968e5.svg";
export { ForwardRef as ReactComponent };